import React from 'react'

import { ArrowRight20Regular } from '@fluentui/react-icons'
import { convertDate } from '@helpers/dateConvert'
import { useIsMobile } from '@hooks'
import { trackingAPI } from '@services/TrackingAPI'
import { modalCreators } from '@store/ducks/modal'
import { useAppSelector, useAppDispatch } from '@store/hooks'

import { Paragraph } from '../Typography'
import { CardCourseStyles } from './styles'

const {
	Card,
	Image,
	buttonLink,
	LockIcon,
	CardContentTitle,
	CourseName,
	FavoriteIcon,
	FavoriteIconFilled,
	Line,
	AvatarContent,
	userAvatar,
	cardImage,
} = CardCourseStyles

export interface CardProps {
	image: string
	profilePicture?: string
	title: string
	block?: boolean
	url?: string
	name?: string
	onClick?: () => void
	onFavorite?: () => void
	date?: string
	isFavorite?: boolean
}

export const CardCourse = ({
	image,
	title,
	block,
	url = '',
	profilePicture,
	name,
	onClick,
	onFavorite,
	date,
	isFavorite,
}: CardProps) => {
	const {
		profile: { id: clientId },
	} = useAppSelector((state) => state)
	const dispatch = useAppDispatch()
	const mobile = useIsMobile()

	const [setTracking] = trackingAPI.useSetTrackingMutation()

	return (
		<>
			{block ? (
				<Card
					style={{ cursor: 'pointer' }}
					onClick={() =>
						dispatch(
							modalCreators.openModal({
								name: 'freeLimit',
								modalInfo: {
									title: 'Adquira agora esse curso!',
									noShowInfo: true,
									button: {
										url,
										label: 'Eu quero',
										action() {
											setTracking({
												clientId,
												action: 'classCTA',
											})
										},
									},
								},
							})
						)
					}
				>
					<div className={CardContentTitle()}>
						<div style={{ display: 'flex', gap: 14 }}>
							<Image>
								{image ? (
									<img src={image} alt={title} className={cardImage()} />
								) : (
									<img
										src='/assets/svg/logo-untitled.svg'
										alt={title}
										style={{ width: 50, height: 50 }}
									/>
								)}
							</Image>

							<CourseName>{title}</CourseName>
						</div>

						<LockIcon />
					</div>
					<div>
						<Line />

						<AvatarContent>
							<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
								<Paragraph
									paragraphType='p1'
									css={{ color: '$neutral100', fontSize: '16px' }}
								>
									Se interessou pelo curso?
								</Paragraph>
							</div>
							<button className={buttonLink()} type='button'>
								<Paragraph
									paragraphType='p1'
									css={{ color: '$blue20', fontWeight: '$bold' }}
								>
									Saiba mais
								</Paragraph>
								<ArrowRight20Regular />
							</button>
						</AvatarContent>
					</div>
				</Card>
			) : (
				<Card>
					<div className={CardContentTitle()}>
						<div style={{ display: 'flex', gap: 14 }}>
							<Image>
								{image ? (
									<img src={image} alt={title} className={cardImage()} />
								) : (
									<img
										src='/assets/svg/logo-untitled.svg'
										alt={title}
										style={{ width: 50, height: 50 }}
									/>
								)}
							</Image>

							<CourseName>{title}</CourseName>
						</div>

						<button
							type='button'
							onClick={onFavorite}
							style={{ display: 'flex', alignSelf: 'self-start' }}
						>
							{!isFavorite ? <FavoriteIcon /> : <FavoriteIconFilled />}
						</button>
					</div>
					<div>
						<Line />

						<AvatarContent>
							<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
								{date && (
									<>
										{profilePicture ? (
											<img src='/assets/svg/logo-untitled.svg' alt='aa' />
										) : (
											<div className={userAvatar()}>
												{name?.charAt(0).toUpperCase()}
											</div>
										)}

										<Paragraph
											paragraphType='p1'
											css={{ color: '$neutral80', fontSize: '12px' }}
										>
											{!mobile ? (
												`Você abriu - ${convertDate(date)}`
											) : (
												<span>
													Você abriu - <br />
													{convertDate(date)}
												</span>
											)}
										</Paragraph>
									</>
								)}
							</div>
							<div className={buttonLink()} onClick={onClick}>
								<Paragraph
									paragraphType='p1'
									css={{ color: '$blue20', fontWeight: '$bold' }}
								>
									Acessar
								</Paragraph>
								<ArrowRight20Regular />
							</div>
						</AvatarContent>
					</div>
				</Card>
			)}
		</>
	)
}
